import { useEffect } from 'react';
import TheGrid from '../components/TheGrid';
import { useKittiesStore } from '../hooks/useKittiesStore';
import Spinner from './Spinner';
import { useAllKitties } from '../hooks/useAllKitties';

function TheKittiesPage({ title, gen }) {
  const { setCurrentGen, kitties, filters } = useKittiesStore();
  const { isLoading } = useAllKitties();

  useEffect(() => {
    if (gen) {
      setCurrentGen(gen);
    }
  }, [gen, setCurrentGen]);

  if (isLoading) {
    return (
      <div className='h-[400px] flex items-center justify-center'>
        <Spinner />
      </div>
    );
  }

  return (
    <main>
      <div className='px-4 lg:px-8'>
        <TheGrid title={title} kitties={kitties} filters={filters} itemsPerPage={25} />
      </div>
    </main>
  );
}

export default TheKittiesPage;
